<div class="box-shadow module">
  <a #msgFocusId href=""></a>

  <div class="row">
    <h2 [innerHTML]="pageTitle | translate"></h2>
  </div>

  <form (ngSubmit)="importMocCreatePssr()" name="addPSSRForm" #addPSSRForm="ngForm">
    <div class="group">
      <div class="group-header">
        <h3>{{ "Location" | translate }}</h3>
      </div>

      <div class="group-item col-md-3">
        <label>{{ "BusinessUnit" | translate }}</label>
        <p-dropdown id="selectBU" name="selectBU" [appBUSwitcher]="selectedBU" [options]="lstBUs"
          [(ngModel)]="selectedBU" [styleClass]="'text-left'" [style]="{ width: '100%' }" (onChange)="changeBU()"
          optionLabel="Name" appendTo="body" (onClick)="loadBUs()" placeholder="{{ 'Select Option' | translate }}">
        </p-dropdown>
      </div>

      <div class="group-item col-md-3">
        <label>{{ (selectedBU.OrganizationLabel || 'Organization') | translate }} </label>
        <p-dropdown id="selectOrg" name="selectOrg" [appBUSwitcher]="selectedOrg" [options]="lstOrgs"
          [(ngModel)]="selectedOrg" [styleClass]="'text-left'" [style]="{ width: '100%' }"
          (onChange)="changeOrganization()" optionLabel="Name" appendTo="body" (onClick)="loadOrganizations()"
          placeholder="{{ 'Select Option' | translate }}" [disabled]="!(selectedBU !== null && selectedBU?.Id &gt; 0)">
        </p-dropdown>
      </div>

      <div class="group-item col-md-3">
        <label>{{ (selectedBU.HierarchyLabel1 || 'HierarchyLabel1') | translate }} </label>
        <p-dropdown id="selectArea" name="selectArea" [options]="lstArea" [(ngModel)]="selectedArea"
          [styleClass]="'text-left'" (onClick)="loadArea()" [style]="{ width: '100%' }" (onChange)="changeArea()"
          optionLabel="Name" appendTo="body" placeholder="{{ 'Select Option' | translate }}"
          [disabled]="!(selectedOrg !== null && selectedOrg?.Id  &gt; 0)">
        </p-dropdown>
      </div>

      <div class="group-item col-md-3">
        <label>{{ (selectedBU.HierarchyLabel2 || 'HierarchyLabel2') | translate }} </label>
        <p-dropdown id="selectSubArea" name="selectSubArea" [options]="lstSubArea" [(ngModel)]="selectedSubArea"
          [styleClass]="'text-left'" (onClick)="loadSubArea()" [style]="{ width: '100%' }" optionLabel="Name"
          appendTo="body" placeholder="{{ 'Select Option' | translate }}" (onChange)="onChangeDisableAll()"
          [disabled]="!(selectedArea && selectedArea?.Id  &gt; 0)">
        </p-dropdown>
      </div>
    </div>

    <div class="group">
      <div class="group-header">
        <h3>{{ "Import" | translate }}</h3>
      </div>

      <div class="group-item col-md-5">
        <label>{{'Import.MOC.ID' | translate}}</label>
        <input type="text" required pattern="^[a-zA-Z0-9-_]+$" class="form-control text-box single-line" maxlength="20"
          [(ngModel)]="pssrId" name="pssrIdText" [readonly]="isMocIdReadonly"
          [disabled]="importMOCStarted || disableAll" #pssrIdText="ngModel" />
      </div>

      <div class="group-item col-md-5">
        <label>{{'Import.MOC.Name' | translate}}</label>
        <input type="text" required class="form-control text-box single-line" maxlength="500" [(ngModel)]="pssrText"
          name="pssrText" [readonly]="isMocIdReadonly" [disabled]="importMOCStarted || disableAll" />
      </div>

      <div class="group-item col-md-2">
        <button id="importMocCreatePssr" [disabled]="!addPSSRForm.form.valid || importMOCStarted || disableAll"
          type="submit" class="btn btn-primary" style="width: 100%" (click)="importMocCreatePssr()">
          {{ 'Import.MOC.Create.PSSR' | translate }}
        </button>
      </div>

    </div>
  </form>

  <div class="group" *ngIf="!!newPssr.pssrId">
    <div class="group-item col-md-12">
      <div class="row">
        <table class="table table-hover table-condensed">
          <thead>
            <tr class="bg-info">

              <th id="thPSSRId" style="width:5%;">
                {{ "PSSR ID" | translate }}
              </th>
              <th id="thName" style="width:80%;">
                {{ "Name" | translate }}
              </th>
              <th id="thStatus" style="width:10%;">
                {{ "Status" | translate }}
              </th>
            </tr>
          </thead>

          <tbody *ngIf="newPssr.pssrId">
            <tr>
              <td style="width:5%;">
                <span class="row">
                  <a *ngIf="!!newPssr.pssrId" (click)="editPSSR(newPssr.pssrId)" style="cursor: pointer"
                    target="_blank">{{ newPssr.pssrId }}</a>
                </span>
              </td>
              <td style="width:80%;">
                {{newPssr.name}}
              </td>
              <td *ngIf="newPssr.status === ImportStatusEnum.Error" style="width:10%;">
                <div class="import-status-error" title="{{newPssr.error}}">
                  <span class="error-row">{{ "Error" | translate }} </span>
                  <i style="padding-top:1px;" class="pi pi-exclamation-triangle error-row"></i>
                </div>
              </td>
              <td *ngIf="newPssr.status === ImportStatusEnum.Warning" style="width:10%;">
                <div class="import-status-error" title="{{newPssr.error}}">
                  <span class="warning-row">{{ "Warning" | translate }} </span>
                  <i style="padding-top:1px;" class="pi pi-exclamation-triangle warning-row"></i>
                </div>
              </td>
              <td *ngIf="newPssr.status !== ImportStatusEnum.Error && newPssr.status !==ImportStatusEnum.Warning"
                class="col-sm-2">
                {{ getStatusText(newPssr.status) | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>